const SvgMaze = ({ grid, cellSize = 30, playerPos }) => {
  const cols = grid[0].length;
  const rows = grid.length;

  const width = cols * cellSize;
  const height = rows * cellSize;

  return (
      <svg width={width} height={height} style={{ background: 'black', stroke: 'white' }}>
        {grid.flatMap(row =>
            row.map(cell => {
            const x = cell.x * cellSize;
            const y = cell.y * cellSize;
            const lines = [
                cell.walls[0] && <line key={`t-${x}-${y}`} x1={x} y1={y} x2={x + cellSize} y2={y} />,
                cell.walls[1] && <line key={`r-${x}-${y}`} x1={x + cellSize} y1={y} x2={x + cellSize} y2={y + cellSize} />,
                cell.walls[2] && <line key={`b-${x}-${y}`} x1={x + cellSize} y1={y + cellSize} x2={x} y2={y + cellSize} />,
                cell.walls[3] && <line key={`l-${x}-${y}`} x1={x} y1={y + cellSize} x2={x} y2={y} />
            ];
            return lines.filter(Boolean);
            })
        )}

        {/* Start and End Points */}
        <circle cx={cellSize / 2} cy={cellSize / 2} r={5} fill="lime" />
        <circle cx={(cols - 0.5) * cellSize} cy={(rows - 0.5) * cellSize} r={5} fill="red" />

        {/* Player Position */}
        {playerPos && (
            <circle
            cx={(playerPos.x + 0.5) * cellSize}
            cy={(playerPos.y + 0.5) * cellSize}
            r={6}
            fill="cyan"
            stroke="black"
            strokeWidth={1}
            />
        )}
      </svg>
  );
};

export default SvgMaze;